module.exports = __webpack_public_path__ + "img/time.57f73f9d.svg";